import { Injectable } from '@angular/core';
import { SECONDS_PER_DAY } from '@constants/app.constants';
import { CookieStorageService } from '@services/cookie-storage/cookie-storage.service';

@Injectable({
  providedIn: 'root',
})
export class CookieVerifyService {
  readonly verifyCookie = 'N0_VERIFY_';

  constructor(private cookieStorage: CookieStorageService) {}

  shouldVerify(username: string): boolean {
    return !this.cookieStorage.getItem(this.verifyCookie + username);
  }

  getVerifyCookie(): number {
    return Number(this.cookieStorage.getItem(this.verifyCookie));
  }

  createVerifyCookie(username: string): void {
    this.cookieStorage.setItem(
      this.verifyCookie + username,
      username,
      SECONDS_PER_DAY * 30,
    );
  }
}
